/*
 * Klaviyo cart sync — Eight & Bob (added 2026-10-06)
 * Saves the full Shopify cart to the visitor's Klaviyo profile so the
 * "Carrito abandonado" flow can show every product and link to a checkout
 * with all of them. Only runs for visitors already identified by Klaviyo.
 * Profile properties written: eb_cart_items, eb_cart_permalink,
 * eb_cart_item_count, eb_cart_updated_at.
 */
(function () {
  'use strict';
  if (window.__ebKlaviyoCartSync) return;
  window.__ebKlaviyoCartSync = true;

  var STORAGE_KEY = 'eb_kl_cart_sig';
  var CART_PATTERN = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var MAX_ITEMS = 10;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var timer = null;

  function readSig() {
    try { return window.localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }

  function writeSig(value) {
    try { window.localStorage.setItem(STORAGE_KEY, value); } catch (e) { /* ignore */ }
  }

  function resizeImage(src) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=300';
  }

  function whenKlaviyo(callback, tries) {
    tries = tries || 0;
    if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
      callback(window.klaviyo);
      return;
    }
    if (tries > 40) return; // give up after ~10s
    setTimeout(function () { whenKlaviyo(callback, tries + 1); }, 250);
  }

  function sync() {
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var origin = window.location.origin;
        var items = (cart.items || []).slice(0, MAX_ITEMS).map(function (item) {
          return {
            variant_id: item.variant_id,
            product_id: item.product_id,
            title: item.product_title,
            variant_title: (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '',
            quantity: item.quantity,
            image: resizeImage(item.image),
            url: origin + item.url
          };
        });
        var permalink = items.length
          ? origin + '/cart/' + items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',')
          : '';
        var signature = permalink || 'empty';
        if (signature === readSig()) return;

        whenKlaviyo(function (klaviyo) {
          var check = typeof klaviyo.isIdentified === 'function' ? klaviyo.isIdentified() : Promise.resolve(false);
          Promise.resolve(check)
            .then(function (identified) {
              if (!identified) return null;
              return Promise.resolve(klaviyo.identify({
                eb_cart_items: items,
                eb_cart_permalink: permalink,
                eb_cart_item_count: cart.item_count || 0,
                eb_cart_updated_at: new Date().toISOString()
              })).then(function () { writeSig(signature); });
            })
            .catch(function () { /* ignore */ });
        });
      })
      .catch(function () { /* ignore */ });
  }

  function scheduleSync() {
    clearTimeout(timer);
    timer = setTimeout(sync, 800);
  }

  // Cart changes made with fetch (most themes and apps)
  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch;
    window.fetch = function (input) {
      var url = (input && input.url) ? input.url : String(input);
      var request = originalFetch.apply(window, arguments);
      if (CART_PATTERN.test(url)) {
        request.then(scheduleSync, function () {});
      }
      return request;
    };
  }

  // Cart changes made with XMLHttpRequest (older apps)
  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__ebUrl = url;
    return originalOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__ebUrl && CART_PATTERN.test(String(this.__ebUrl))) {
      this.addEventListener('load', scheduleSync);
    }
    return originalSend.apply(this, arguments);
  };

  // Theme cart events and leaving the page
  ['cart:change', 'cart:refresh', 'cart:updated', 'variant:add'].forEach(function (eventName) {
    document.addEventListener(eventName, scheduleSync);
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') sync();
  });

  // Page load (also covers non-AJAX "add to cart" forms that redirect to /cart)
  scheduleSync();
})();
